import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFastapiComponent } from './simple-icons-fastapi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFastapiComponent ],
    exports:      [ SimpleIconsFastapiComponent ],
    bootstrap:    []
})
export class SimpleIconsFastapiModule {}
